import React from 'react'
import Switch from 'react-switchery'
import moment from 'moment'
import _ from 'lodash'
import '../assets/css/components/filter-banner.css'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faCalendar as farCalendar } from '@fortawesome/free-regular-svg-icons'
import { faSlidersH, faTimes } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import StudentGroupingsPopoutFilter from './StudentGroupingsPopoutFilter'
import DateFilterPopoutButton from './DateFilterPopoutButton'
import ContentTypesPopoutFilter from './ContentTypesPopoutFilter'
library.add(farCalendar, faSlidersH, faTimes)

// Scroll logic from https://gist.github.com/koistya/934a4e452b61017ad611
let lastScrollY = 0;
let ticking = false;

class FilterBanner extends React.Component {
  constructor(props) {
    super(props)
    this.container = React.createRef();
  }

  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll);
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  handleScroll = () => {
    lastScrollY = window.scrollY;

    if (!ticking) {
      window.requestAnimationFrame(() => {
        if(lastScrollY >= 261) {
          this.container.current.style.position = 'fixed'
          this.container.current.style.top = '32px';
          this.container.current.style.zIndex = 999;
          this.container.current.style.marginLeft = '70px';
        } else {
          this.container.current.style = { positon: 'absolute' }
        }
        ticking = false;
      });

      ticking = true;
    }
  };

  getFilteredCourses = ()=>
    _.filter(this.props.courseCollection, course => !!_.find(this.props.committedCourseIds, id => id == course.value))

  getFilteredSections = ()=>
    _.filter(this.props.sectionCollection, section => !!_.find(this.props.committedSectionIds, id => id == section.value))

  getFilteredStudents = ()=>
    _.filter(this.props.studentCollection, student => !!_.find(this.props.committedStudentIds, id => id == student.value))

  getFilteredContentTypes = ()=>
    _.filter(this.props.contentTypes, contentType => !!_.find(this.props.committedContentTypes, id => id == contentType.value))

  /*TODO: figure out a way to add content types to appliedFilterCount*/
  getAppliedFilterCount = ()=>
    this.getFilteredCourses().length + this.getFilteredSections().length + this.getFilteredStudents().length + _.compact([this.props.committedStartingDate + this.props.committedEndingDate]).length + this.getFilteredContentTypes().length

  handleToggleCommittedCourseId = id => this.props.toggleCommittedCourseId(id)
  handleToggleCommittedSectionId = id => this.props.toggleCommittedSectionId(id)
  handleToggleCommittedStudentId = id => this.props.toggleCommittedStudentId(id)
  handleToggleCommittedContentType = contentType => this.props.toggleCommittedContentType(contentType)

  getDateFilterText = ()=>{
    const { committedStartingDate, committedEndingDate } = this.props
    const formattedStartingDate = committedStartingDate ? moment(committedStartingDate).format('MM-DD-YYYY') : undefined
    const formattedEndingDate = committedEndingDate ? moment(committedEndingDate).format('MM-DD-YYYY') : undefined

    if(formattedStartingDate && formattedEndingDate) {
      return `From ${formattedStartingDate} to ${formattedEndingDate}`
    } else if(formattedStartingDate) {
      return `From ${formattedStartingDate} onwards`
    } else {
      return `Before ${formattedEndingDate}`
    }
  }

  render() {
    // Collections for Dropdown
    const { courseCollection, sectionCollection, studentCollection, hasDateFilter, hasContentFilter, contentTypes } = this.props
    // Current selections/committed ids
    const {
      selectedCourseIds,
      selectedSectionIds,
      selectedStudentIds,
      selectedStartingDate,
      selectedEndingDate,
      selectedContentTypes,
      committedCourseIds,
      committedSectionIds,
      committedStudentIds,
      committedContentTypes,
      showMeModeToggle,
      onToggleMeMode,
      meMode
    } = this.props

    // State callbacks
    const { toggleCourseId, toggleSectionId, toggleStudentId, toggleContentType, selectStartingDate, selectEndingDate, removeCommittedDateFilters, toggleCommittedCourseId, toggleCommittedSectionId, toggleCommittedStudentId, toggleCommittedContentType, onApply, onCancel } = this.props

    return(
      <div id='filter-banner-wrapper' className={this.getAppliedFilterCount() === 0 ? undefined : 'currently-filtered'}>
        <div ref={this.container} id='filter-banner'>
          <div id='filter-contents' className={this.getAppliedFilterCount() === 0 ? undefined : 'currently-filtered'}>
            <div className='spacing'></div>

            <h2 className='text-uppercase'>Filter Data</h2>

            { hasDateFilter &&
              <div className='date-range-wrapper'>
                <DateFilterPopoutButton
                  onApply={onApply}
                  onCancel={onCancel}
                  selectedStartingDate={selectedStartingDate}
                  selectedEndingDate={selectedEndingDate}
                  onSelectStartingDate={selectStartingDate}
                  onSelectEndingDate={selectEndingDate}
                  removeCommittedDateFilters={removeCommittedDateFilters}
                  backgroundWhite={true}/>
              </div>
            }
            { hasContentFilter &&
              <div className='content-types-wrapper'>
                <ContentTypesPopoutFilter
                  onApply={onApply}
                  onCancel={onCancel}
                  contentTypes={contentTypes}
                  selectedContentTypes={selectedContentTypes}
                  toggleContentType={toggleContentType}
                  title='Filter By Assignment Type'
                  iconComponent={<FontAwesomeIcon icon='sliders-h'/>}
                />
              </div>
            }
            <div className='student-groupings-wrapper'>
              <StudentGroupingsPopoutFilter
                disabled={meMode}
                title='Filter By Course/Class/Student'
                iconComponent={<FontAwesomeIcon icon='sliders-h'/>}
                courseCollection={courseCollection}
                sectionCollection={sectionCollection}
                studentCollection={studentCollection}
                selectedCourseIds={selectedCourseIds}
                selectedSectionIds={selectedSectionIds}
                selectedStudentIds={selectedStudentIds}
                toggleCourseId={toggleCourseId}
                toggleSectionId={toggleSectionId}
                toggleStudentId={toggleStudentId}
                onApply={onApply}
                onCancel={onCancel}
              />
            </div>
            { showMeModeToggle &&
              <div className='me-mode-toggle'>
                <span className='text'>Myself</span>
                <Switch
                  className="switch-class"
                  type='checkbox'
                  onChange={onToggleMeMode}
                  options={{
                    size:           'small',
                    color:          '#40bbde',
                    secondaryColor: '#40bbde'
                  }}
                  checked={!meMode}
                />
                <span className='text'>Students</span>
              </div>
            }


            {this.getAppliedFilterCount() > 0 &&
              <div className='applied-filters-container'>
                <div className='divider'></div>
                <h4>Applied Filters:</h4>
                <div className='filter-item-container'>
                  {_.map(this.getFilteredCourses(), (course,index)=>
                    <div key={'course'+index} onClick={()=>this.handleToggleCommittedCourseId(course.value)} className='filter-item'>
                      <span>{course.label}</span><FontAwesomeIcon icon='times'/>
                    </div>
                  )}
                  {_.map(this.getFilteredSections(), (section,index) =>
                    <div key={'section'+index} onClick={()=>this.handleToggleCommittedSectionId(section.value)} className='filter-item'>
                      <span>{section.label}</span><FontAwesomeIcon icon='times'/>
                    </div>
                  )}
                  {_.map(this.getFilteredStudents(), (student,index) =>
                    <div key={'student'+index} onClick={()=>this.handleToggleCommittedStudentId(student.value)} className='filter-item'>
                      <span>{student.label}</span><FontAwesomeIcon icon='times'/>
                    </div>
                  )}
                  {_.map(this.getFilteredContentTypes(), (contentType, index) =>
                    <div key={'contentType'+index} onClick={()=>this.handleToggleCommittedContentType(contentType.value)} className='filter-item'>
                      <span>{contentType.label}</span><FontAwesomeIcon icon='times'/>
                    </div>
                  )}
                  {(this.props.committedStartingDate || this.props.committedEndingDate) &&
                    <div onClick={this.props.removeCommittedDateFilters} className='filter-item'>
                      <span>{this.getDateFilterText()}</span><FontAwesomeIcon icon='times'/>
                    </div>
                  }
                </div>
              </div>
            }
          </div>
        </div>
      </div>
    )
  }
}

export default FilterBanner
